/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_ProInputs */

const en_landing_pricing_pro = /** @type {(inputs: Landing_Pricing_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const zh_landing_pricing_pro = /** @type {(inputs: Landing_Pricing_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业版`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Landing_Pricing_ProInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_pro = /** @type {((inputs?: Landing_Pricing_ProInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_ProInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_pro(inputs)
	return zh_landing_pricing_pro(inputs)
});
export { landing_pricing_pro as "landing.pricing.pro" }